import { useState } from 'react'

/**
 * Página de mantenimiento.
 * Componente autocontenido: no requiere Tailwind ni props.
 * Ajusta los valores de `estado` para reflejar el progreso real.
 */

const estado = {
  progreso: 62, // porcentaje completado, 0-100
  inicio: '09:00',
  fin: '13:00',
  etaHoras: '4h' // tiempo estimado restante
}

export default function MaintenancePage() {
  return (
    <div
      className="w-100 position-relative h-screen w-screen bg-gradient-to-r from-[#27215D] to-gray-500 overflow-hidden flex justify-center items-center"
      style={styles.page}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500;600;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

        * { box-sizing: border-box; }
        body { margin: 0; }

        .mp-input:focus-visible,
        .mp-button:focus-visible {
          outline: 2px solid #F5A623;
          outline-offset: 2px;
        }

        @media (prefers-reduced-motion: no-preference) {
          .mp-bar-fill {
            transition: width 900ms cubic-bezier(0.22, 1, 0.36, 1);
          }
        }
      `}</style>

      <div style={styles.stripe} aria-hidden="true" />

      <main
        className="bg-white border-2 rounded border-[#26374E]"
        style={styles.panel}
      >
        <div style={styles.tag}>
          <span style={styles.tagDot} aria-hidden="true" />
          Manteniment
        </div>

        <h1 className="mp-headline" style={styles.headline}>
          Estem treballant per millorar el sistema
        </h1>

        <p style={styles.body}>
          Estem aplicant unes millores al sistema i, per això, el servei no
          estarà disponible temporalment.
        </p>

        <p style={styles.body}>
          <strong className="text-indigo-800">
            Estarem disponibles de nou el dilluns 07/09/2026 a les 12:00 h.
          </strong>
        </p>

        <p style={styles.body}>
          Disculpeu les molèsties i moltes gràcies per la vostra paciència i
          comprensió.
        </p>
      </main>
    </div>
  )
}

const styles = {
  page: {
    fontFamily: "'Inter', system-ui, sans-serif",
    padding: '24px'
  },
  stripe: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '10px',
    background:
      'repeating-linear-gradient(-45deg, #F5A623, #F5A623 14px, #0E1826 14px, #0E1826 28px)'
  },
  panel: {
    width: '100%',
    maxWidth: '480px',
    padding: '48px 44px',
    position: 'relative'
  },
  tag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    color: '#B9740F',
    fontWeight: 600,
    marginBottom: '20px',
    letterSpacing: '0.01em'
  },
  tagDot: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    background: '#F5A623',
    display: 'inline-block'
  },
  headline: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontWeight: 700,
    fontSize: '42px',
    lineHeight: 1.08,
    color: '#0E1826',
    margin: '0 0 16px 0',
    letterSpacing: '0.002em'
  },
  body: {
    fontSize: '15.5px',
    lineHeight: 1.6,
    color: '#4B5A6B',
    margin: '0 0 10px 0',
    maxWidth: '42ch'
  },
  statusBlock: {
    background: '#F4F6F8',
    border: '1px solid #D9E1EA',
    padding: '18px 20px',
    marginBottom: '32px'
  },
  statusColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  statusLabel: {
    fontSize: '12.5px',
    color: '#5A6B80',
    fontFamily: "'JetBrains Mono', monospace"
  },
  statusValue: {
    fontSize: '12.5px',
    color: '#0E1826',
    fontFamily: "'JetBrains Mono', monospace",
    fontWeight: 700
  },
  barTrack: {
    height: '6px',
    background: '#1E2E44',
    margin: '10px 0',
    overflow: 'hidden'
  },
  barFill: {
    height: '100%',
    background: '#F5A623'
  },
  form: {
    marginBottom: '28px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    color: '#9AA7B9',
    marginBottom: '10px'
  },
  formRow: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },
  input: {
    flex: '1 1 180px',
    background: '#0E1826',
    border: '1px solid #26374E',
    color: '#ECEEF1',
    padding: '11px 14px',
    fontSize: '14px',
    fontFamily: 'inherit'
  },
  button: {
    background: '#F5A623',
    border: 'none',
    color: '#0E1826',
    padding: '11px 20px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit'
  },
  confirm: {
    fontSize: '14px',
    color: '#ECEEF1',
    background: '#0E1826',
    border: '1px solid #26374E',
    padding: '14px 16px',
    margin: 0
  },
  footer: {
    fontSize: '13px',
    color: '#7C8BA0',
    borderTop: '1px solid #26374E',
    paddingTop: '20px'
  },
  link: {
    color: '#F5A623',
    textDecoration: 'none'
  }
}
